export default "__VITE_ASSET__BQApGGMu__"